<template>
  <project-detail-layout :tab="5">
    <div class="history-project-ctn">
      <div class="ptable_wrapper">
        <div class="btn_group">
          <button class="btn_img" type="button" @click="show = true">
            <img alt="xls_icon" src="@/assets/icons/plus_his.svg"/>
          </button>
          <button class="confirm-button" @click="show = true">
            {{
              $t(
                "project_management.project_detail.button_title.add_contract_history"
              )
            }}
          </button>
        </div>
        <div class="table_wrapper">
          <table class="table ptable">
            <thead class="ptable__thead">
            <tr>
              <th class="vertical_align">
                {{ $t("project_management.project_detail.table_column.no") }}
              </th>
              <th class="vertical_align">
                {{
                  $t("project_management.project_detail.table_column.start_date")
                }}
              </th>
              <th class="vertical_align">
                {{
                  $t("project_management.project_detail.table_column.end_date")
                }}
              </th>
              <th class="vertical_align">
                {{
                  $t(
                    "project_management.project_detail.table_column.quotation_documents"
                  )
                }}
              </th>
              <th class="vertical_align">
                {{
                  $t(
                    "project_management.project_detail.table_column.timesheet"
                  )
                }}
              </th>
              <th class="action">
                {{
                  $t(
                    "project_management.project_detail.table_column.manipulation"
                  )
                }}
              </th>
            </tr>
            </thead>
            <tbody
              v-for="(item, key) in contract_management"
              :key="key"
              class="ptable__tbody"
            >
            <tr>
              <td>{{ key + 1 }}</td>
              <td>{{ item.start_date }}</td>
              <td>{{ item.end_date }}</td>
              <td class="quotation_documents">
                <div class="quotation_documents__group">
                  <img alt="xls_icon" src="@/assets/icons/xls_icon.svg"/>
                  <a
                    :href="`${item.document_quote_link}`"
                    class="text-break text-left"
                    download
                  >
                    {{ item.document_quote_name }}
                  </a>
                </div>
              </td>
              <td>{{ item.cost }}MM</td>
              <td class="manipulation">
                <div class="manipulation__group">
                  <button type="button" @click="editContract(item.id)">
                    <img
                      alt="pencil"
                      src="@/assets/icons/icon_edit_his.svg"
                      @click="show = true"
                    />
                  </button>
                  <button type="button" @click="delContractHistory(item.id)">
                    <img
                      alt="trash"
                      src="@/assets/icons/icon_delete_his.svg"
                    />
                  </button>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

      <b-modal
        ref="modal"
        v-model="show"
        centered
        class="b-modal"
        hide-footer
        title="Submit Your Name"
        @hidden="resetContract"
      >
        <template #modal-title>
          <div v-if="!isEdit">
            {{
              $t(
                "project_management.project_detail.button_title.add_contract_history"
              )
            }}
          </div>
          <div v-if="isEdit">
            {{
              $t(
                "project_management.project_detail.button_title.edit_contract_history"
              )
            }}
          </div>
        </template>
        <ValidationObserver ref="effortForm" v-slot="{ handleSubmit }">
          <Form @submit.prevent="handleSubmit(onSubmit)">
            <div class="input-wrapper">
              <div class="label">
                {{ $t("project_management.project_detail.table_column.start_date") }}
              </div>
              <ValidationProvider
                v-slot="{ errors }"
                :name="$t('fields.project_detail.project.start_date')"
              >
                <DatePicker
                  v-model="newContract.start_date"
                  :clearable="false"
                  :editable="false"
                  :placeholder="'DD/MM/YYYY'"
                  format="DD/MM/YYYY"
                  value-type="format"
                />
                <div class="validation_error">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>
            <div class="input-wrapper">
              <div class="label">
                {{ $t("project_management.project_detail.table_column.end_date") }}
              </div>
              <ValidationProvider
                v-slot="{ errors }"
                :name="$t('fields.project_detail.project.end_date')"
              >
                <DatePicker
                  v-model="newContract.end_date"
                  :clearable="false"
                  :editable="false"
                  :placeholder="'DD/MM/YYYY'"
                  format="DD/MM/YYYY"
                  value-type="format"
                />
                <div class="validation_error">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>
            <div class="input-wrapper">
              <div class="label">
                {{
                  $t(
                    "project_management.project_detail.table_column.quotation_documents"
                  )
                }}
              </div>
              <ValidationProvider
                ref="provider"
                v-slot="{ validate, errors }"
                :name="$t('fields.project_detail.project.quotation_documents')"
              >
                <input
                  id="fileXlsx"
                  ref="file"
                  accept=".xlsx, .xls, pdf"
                  class="form-control-file"
                  style="display: none"
                  type="file"
                  @change="onChangeFile($event) || validate($event)"
                />
                <div class="document_wrapper">
                  <label for="fileXlsx">
                    <img alt="pdf_icon" src="@/assets/icons/pdf_icon.svg"/>
                    <span>
                      {{
                        $t(
                          "project_management.project_detail.button_title.choose_file"
                        )
                      }}
                    </span>
                  </label>
                  <span class="ml-2 text-break">{{
                      newContract.document_quote_name
                    }}</span>
                </div>
                <div class="validation_error">{{ errors[0] }}</div>
                <div v-if="fileError" class="validation_error">
                  {{ fileErrorText }}
                </div>
              </ValidationProvider>
              <!-- <span v-if="!isImage" class="error image required">
                  {{ errorFileMessage }}
                </span> -->
            </div>

            <div class="input-wrapper effort">
              <div class="label">
                {{
                  $t("project_management.project_detail.table_column.timesheet")
                }}
                (MM)
              </div>
              <ValidationProvider
                v-slot="{ errors }"
                :name="$t('fields.project_detail.project.timesheet')"
                rules="min_value:0|max_value:99999999"
              >
                <input
                  v-model="newContract.cost"
                  placeholder="Nhập công số"
                  type="number"
                  step="0.01"
                  v-on:keyup.enter="(event) => onEnterClick(event)"
                />
                <div class="validation_error">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>

            <div class="btn_group">
              <button class="confirm-button" type="submit">
                {{ $t("project.activity.activity_button_submit") }}
              </button>
              <button class="cancel-button" type="button" @click="onCancel">
                {{ $t("project.activity.activity_button_cancel") }}
              </button>
            </div>
          </Form>
        </ValidationObserver>
      </b-modal>
    </div>
  </project-detail-layout>
</template>
<script>
import ProjectDetailLayout from "./ProjectDetailLayout.vue";
import {ValidationProvider, ValidationObserver, Form} from "vee-validate";
import DatePicker from "vue2-datepicker";
import { mapActions, mapGetters} from "vuex";
import moment from "moment";

export default {
  components: {
    ProjectDetailLayout,
    ValidationProvider,
    ValidationObserver,
    DatePicker,
    Form,
  },
  data() {
    return {
      show: false,
      newContract: {
        start_date: "",
        end_date: "",
        document_quote_file: "",
        cost: "",
        document_quote_name: "",
        project_id: this.$route.params.id,
      },
      fileError: false,
      nameFile: "",
      isEdit: false,
      isOnEditChangeDocument: false,
      ruleFile: "",
      disabledBefore: new Date(2019, 10, 2),
      disabledAfter: new Date(2019, 10, 6),
      fileErrorText: "",
    };
  },
  created() {
    this.getContractHistory();
  },
  computed: {
    ...mapGetters({
      contract_management: "project/contract_management",
      startEndDate: "project/startEndDate",
    }),

    indexContact() {
      return 5;
    },
  },
  methods: {
    ...mapActions("layout", ["setLoading"]),
    // disabledRange: function (date) {
    //   return date < this.startEndDate.startDate || date > this.startEndDate.endDate;
    // },
    onEnterClick(event) {
      event.preventDefault();
      return false;
    },
    async delContractHistory(id) {
      const respone = await this.$store.dispatch(
        "project/delContractHistory",
        id
      );
      if (respone.status === 200) {
        this.$toast(
          "Xóa thành công",
          "Thành công",
          2000,
          "b-toaster-top-center",
          "success"
        );
        await this.getContractHistory();
      }
    },
    async getContractHistory() {
      this.setLoading(true);
      const id = this.$route.params.id;
      this.$store.dispatch("project/getContractManagement", {
        id,
        date: this.dateFormat,
      });
      this.setLoading(false);
    },
    async openModal() {
      this.show = true;
    },
    onCancel() {
      this.show = false;
      this.isOnEditChangeDocument = false;
      this.fileError = false;
    },
    resetContract() {
      this.newContract = {
        start_date: "",
        end_date: "",
        document_quote_file: "",
        cost: "",
        document_quote_name: "",
        project_id: this.$route.params.id,
      };
      this.nameFile = "";
      this.ruleFile = "";
      this.isEdit = false;
      this.fileError = false;
    },
    async editContract(id) {
      this.ruleFile = "";
      this.contract_management.filter((item) => {
        if (item.id === id) {
          this.newContract = {...item};
        }
      });
      this.isEdit = true;
    },
    formatDate(date) {
      if (!date) return '';
      return moment(date).format("DD/MM/YYYY");
    },
    async onChangeFile(e) {
      await this.$refs.provider?.validate(e);
      let file = e.target.files[0];
      const maxSize = 5;
      const extensions = ["xlsx", "pdf", "xls", "csv"];
      let fileSize = file.size / (1024 * 1024);
      let fileNameExt = file.name.split(".").pop();
      this.newContract.document_quote_name = file.name;
      if (!extensions.includes(fileNameExt.toLowerCase())) {
        this.fileError = true;
        this.fileErrorText = "Hãy nhập đúng định dạng file .csv .xlsx .xls";
        return;
      } else if (fileSize > maxSize) {
        this.fileError = true;
        this.fileErrorText = "Dung lượng file quá lớn";
        return;
      }
      if (this.isEdit) {
        this.isOnEditChangeDocument = true;
      }
      this.newContract.document_quote_file = file;
      return (this.fileError = false);
    },
    async onSubmit() {
      if (this.fileError) {
        return;
      }
      const startDate = this.newContract.start_date ? this.formatDate(this.newContract.start_date) : '';
      const endDate = this.newContract.end_date ? this.formatDate(this.newContract.end_date) : '';
      let contractCustom = {
        start_date: startDate,
        end_date: endDate,
        ...this.newContract,
      };
      let formData = new FormData();
      for (let key in contractCustom) {
        formData.append(key, contractCustom[key]);
      }
      let respone;
      if (this.isEdit) {
        if (!this.isOnEditChangeDocument) {
          delete contractCustom.document_quote_link;
          delete contractCustom.document_quote_name;
        }
        respone = await this.$store.dispatch(
          "project/updateContractHistory",
          formData
        );
        this.resetContract();
        this.isEdit = false;
      } else {
        this.show = false;
        respone = await this.$store.dispatch(
          "project/postContractHistory",
          formData
        );
      }
      if (respone?.status === 200) {
        this.$toast(
          "Lưu thành công",
          "Thành công",
          2000,
          "b-toaster-top-center",
          "success"
        );
        this.resetContract();
        this.show = false;
        this.isOnEditChangeDocument = false;
        await this.getContractHistory();
      } else if (respone.status === 500) {
        this.$toast(
          "Đã có lỗi xảy ra",
          "Lỗi",
          2000,
          "b-toaster-top-center",
          "error"
        );
        this.show = false;
        this.isOnEditChangeDocument = false;
      }
    },
  },
};
</script>
<style lang="scss">
.history-project-ctn {
  margin: 0 auto;
  padding: 0 30px;

  .table_wrapper {
    max-height: 540px;
    overflow: auto;
    @media only screen and (max-width: 1300px) {
      max-height: 300px;
    }
  }

  .ptable {
    --border: 1px solid #efefef;
    border-radius: 10px;
    border-spacing: 0;
    border-collapse: separate;
    border: var(--border);
    border-top: 0;
    overflow: hidden;

    & th:not(:last-child),
    & td:not(:last-child) {
      border-right: var(--border);
    }

    & > thead > tr:not(:last-child) > th,
    & > thead > tr:not(:last-child) > td,
    & > tbody > tr:not(:last-child) > th,
    & > tbody > tr:not(:last-child) > td,
    & > tfoot > tr:not(:last-child) > th,
    & > tfoot > tr:not(:last-child) > td,
    & > tr:not(:last-child) > td,
    & > tr:not(:last-child) > th,
    & > thead:not(:last-child),
    & > tbody:not(:last-child),
    & > tfoot:not(:last-child) {
      border-bottom: var(--border);
    }

    &__thead {
      padding: 1em;
      background: #3488eb;
      border-radius: 10px 10px 0px 0px;

      th {
        text-align: center;
        font-style: normal;
        font-weight: 700;
        font-size: 14px;
        line-height: 17px;
        color: #ffffff;
        border-bottom: 0 !important;
        border-right: 1px solid;
        height: 44px;

        &.action {
          min-width: 85px;
        }

        &:nth-child(1) {
          width: 7%;
        }

        &:nth-child(2) {
          width: 20%;
        }

        &:nth-child(4) {
          width: 20%;
        }

        &:nth-child(5) {
          width: 10%;
        }
      }
    }

    &__tbody {
      padding: 1em;

      td {
        text-align: center;
        font-weight: 400;
        font-size: 14px;
        line-height: 17px;
        color: #303c54;
        border: 1px solid #efefef;
        vertical-align: middle;
      }

      .manipulation {
        &__group {
          button {
            width: 24px;
            height: 24px;
            border: none;
            padding: 0;
            background: none;
            outline: none;

            &:first-child {
              margin-right: 10px;
            }

            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }

      .quotation_documents {
        &__group {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          width: 55%;
          margin: auto;

          img {
            margin-right: 10px;
          }

          a.text-break.text-left {
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
        }
      }
    }

    .ptable_input_wrapper {
      width: 100%;
      position: relative;

      .ptable__input {
        width: 100%;
        height: 40px;
        min-width: 150px;
      }

      .ptable__icon {
        position: absolute;
        right: 5px;
        top: 12px;
      }

      .ptable__percentage {
        position: absolute;
        right: 27px;
        top: 12px;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 17px;
        text-align: center;
        color: #303c54;
      }
    }
  }

  .btn_group {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 12px;

    button {
      background: none;
      outline: none;
      border: none;
    }

    .btn_img {
      width: 31px;
      height: 31px;
      border: none;
      padding: 0;

      &:first-child {
        margin-right: 10px;
      }

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}

.modal-body {
  .input-wrapper {
    font-family: "Roboto";
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    width: 100%;

    .label {
      font-weight: 600;
      font-size: 14px;
      color: #303c54;
      margin-bottom: 8px;

      .required {
        color: red;
      }
    }

    input:not([type="file"]) {
      background: #ffffff;
      border: 1px solid #cfcfcf;
      border-radius: 5px;
      height: 40px;
      padding: 10px;
      width: 100%;

      &:focus {
        color: #768192;
        background-color: #fff;
        border-color: #958bef;
        outline: 0;
      }

      &:disabled {
        opacity: 0.65;
      }
    }

    .validation_error {
      font-size: 12px;
      color: red;
    }

    .mx-datepicker {
      width: 100%;
      height: 40px;

      input {
        height: 40px;
      }
    }

    .document_wrapper {
      display: flex;
      align-items: center;

      label {
        margin-bottom: 0;
        border: 1px solid #ededed;
        background: #f8f8f8;
        padding: 6px 17px;
        border-radius: 20px;
        cursor: pointer;
        width: 117px;
        flex: 0 0 25%;
      }
    }
  }

  .btn_group {
    display: flex;
    justify-content: center;

    button {
      width: 172px;
      height: 49px;
      border: 1px solid #6e7a8b;
      border-radius: 5px;
      font-family: "Helvetica Neue", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 17px;
      text-align: center;
      margin-left: 10px;
    }

    .confirm-button {
      background: #118fa6;
      color: #ebf3f4;
    }

    .cancel-button {
      background: #ffffff;
      color: #1f2d3d;
    }
  }
}
</style>
